module.exports = __webpack_public_path__ + "img/icon-startup-white.96438373.svg";